export default __webpack_public_path__ + "img/vector_1.29235823.svg";